//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import rushRed from './components/rushRed.vue'
export default {
    props: {
        linkguid: {
            type: String,
            default: ''
        }
    },
    components:{rushRed},
    data () {
        return {
            tableData: [],

            lxMap: {
                '0': '正票',
                '1': '红票'
            },
            isAllExistfphm:false,
            dialogTitle:'',
            rushRedDialog:false,
            fpchRowguid:'',
        }
    },
    computed:{

    },
    watch:{
        rushRedDialog: function(n, o){
            if(!n){
                this.reload();
            }
        },
    },
    methods: {
        reKp:function(row){
            this.$confirm('确认重新开票？','确认',{
                confirmButtonText:'确定',
                cancelButtonText:'取消',
                type:'info',
            }).then(()=>{
                this.$post(this.getStore('finUrl') + '/receipt/cxkp', {
                    rowguid: row.rowguid
                }, (data, res) => {
                    ShowMsg.call(this, res.msg);
                    this.reload();
                });
            }).catch(()=>{
                 this.$message({
                    type: 'info',
                    message: '已取消操作'
                });    
            })
        },
        downloadFp(row) {
            console.log(row);
            // sessionStorage.setItem("src",row.pdf_url);
            // window.open('/#/finance/list-all-receipt/fp-preview');

            // this.goto({      //预览
            //     path: '/finance/list-all-receipt/fp-preview',
            //     query: {
            //         src: row.pdf_url
            //     }
            // })
            if(!!row.pdf_url){
                window.open(row.pdf_url);//下载
            }else{
                this.$message({
                    type: 'error',
                    message: '发票不存在'
                });  
            }
        },
        fpch(row) {
            this.dialogTitle = '冲红';
            this.fpchRowguid = row.rowguid;
            this.rushRedDialog = true;


            // this.$prompt('请输入冲红原因','冲红',{
            //     confirmButtonText:'确定',
            //     cancelButtonText:'取消',
            //     showCancelButton: true,
            //     inputValue: "",
            //     inputValidator:value=>{
            //         if(value === ''){
            //             return false;
            //         }else{
            //             return true;
            //         }
            //     },
            //     inputErrorMessage: '请输入冲红原因'
            // }).then(({value})=>{
            //     this.$post(this.getStore('finUrl') + '/receipt/fpch', {
            //         rowguid: row.rowguid,
            //         chyy:value
            //     }, (data, res) => {
            //         ShowMsg.call(this, res.msg);
            //         this.reload();
            //     });
            // }).catch(()=>{

            // })
        },
        reload:function(){
            this.$get(this.getStore('finUrl') + '/receipt/detail', {
                rowguid: this.linkguid
            }, (data, res) => {
                this.tableData = data;
                //判断fp_hm不为空
                this.isAllExistfphm = this.tableData.every((item)=> {
                    return !!item.fp_hm 
                });
            });
        },
        //开票
        makeInvoice:function(row){
            let that = this;
            let loading = that.$loading({
                lock: true,
                text: '开票中......',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })

            that.$ajax({
                type: 'post',
                url: that.getStore('finUrl') + '/receipt/dzfpSingle',
                data: {
                    rowguid: row.rowguid
                },
                callback: function(data,res ){
                    ShowMsg.call(that, res.msg ,'success');
                    that.reload();
                },
                complete: function() {
                    loading.close();
                }
            })

        },
        //开票完成
        makeInvoiceComplete:function(){
            this.$post(this.getStore('finUrl') + '/receipt/dzfpFinish', {
                rowguid: this.linkguid
            }, (data, res) => {
                ShowMsg.call(this, res.msg ,'success');
                this.$emit('close');
            });
        },
    },
    mounted: function() {
        // this.$get(this.getStore('finUrl') + '/receipt/detail', {
        //     rowguid: this.linkguid
        // }, (data, res) => {
        //     this.tableData = data;
        //     //判断fp_hm不为空
        //     this.isAllExistfphm = this.tableData.every((item)=> {
        //         return !!item.fp_hm 
        //     });
        // });
        this.reload();
    }
}
